/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".payment-method[_ngcontent-%COMP%]{margin-top:30px;white-space:pre-wrap;overflow:scroll}.bottom-button[_ngcontent-%COMP%]{position:absolute;bottom:-5px;right:-2px;left:-2px}.flaticon-pay[_ngcontent-%COMP%]::before{font-size:50px}.pay-icon[_ngcontent-%COMP%]{margin:20px}"];
export { styles as styles };
